<template>
  <div>
    <div v-if="$store.state.stepperPatient">
      <v-container>
        <v-card-title>
          <span>
            <h4>Pesquisar Visitantes Administrativos</h4>
          </span>
        </v-card-title>
        <v-card-text>
          <v-form @submit.prevent="searching">
            <v-row>
              <v-col cols="12" md="3">
                <v-autocomplete
                  dense
                  outlined
                  label="Tipos de Documentos"
                  v-model="search.document_type"
                  @change="search.document_number = null"
                  clearable
                  class="border__radius-15"
                  :items="getDocumentType"
                  item-text="type_document_name"
                  item-value="id"
                />
              </v-col>
              <v-col cols="12" md="3" v-if="search.document_type">
                <!-- NOTE - TERÁ variável search.cpf, rg e cnh -->
                <v-text-field
                  label="Número do documento"
                  outlined
                  class="border__radius-15"
                  dense
                  v-mask="maskDecider"
                  :maxlength="maskDecider.length"
                  v-model="search.document_number"
                  required
                />
              </v-col>
              <!-- <v-col
                cols="12"
                sm="6"
                md="3"
              >
                <v-text-field
                  label="Nome do Visitante"
                  maxlength="255"
                  v-model="search.name"
                  class="border__radius-15"
                  outlined
                  dense
                />
              </v-col> -->
            </v-row>

            <v-card-actions>
              <v-spacer />
              <v-btn
                @click="btlimpar"
                class="float-end border__radius-10"
                style="margin-left: 10px"
              >
                <v-icon size="22" class="icon"> mdi-broom </v-icon>
                <span>Limpar</span>
              </v-btn>
              <v-btn
                elevation="0"
                color="success"
                dark
                type="submit"
                class="border__radius-10"
              >
                <v-icon size="22" class="icon">
                  mdi-magnify-plus-outline
                </v-icon>
                Pesquisar
              </v-btn>
              <v-btn
                elevation="0"
                color="primary"
                dark
                @click="$router.push({ path: '/cad-adm-person' })"
                class="border__radius-10"
              >
                <v-icon size="22" class="icon"> mdi-plus </v-icon>
                Novo
              </v-btn>
            </v-card-actions>
          </v-form>
        </v-card-text>
      </v-container>

      <v-container>
        <v-row>
          <v-data-table
            :headers="headers"
            :items="admVisitors"
            :loading="loading"
            :options.sync="options"
            :items-per-page="options.itemsPerPage"
            :footer-props="{
              'items-per-page-text': 'Pacientes por Página',
              'items-per-page-options': [10, 25, 50, 100, -1],
            }"
            :server-items-length="options.totalItems"
            @update:options="searching"
            class="elevation-1"
          >
            <template v-slot:[`item.entry_date_and_time`]="{ item }">
              {{ formatDateTime(item.entry_date_and_time) }}
            </template>

            <template v-slot:[`item.visitor_sector`]="{ item }">
              {{item.visitor_sector == "Outros"
                ? item.others_sectors
                : item.visitor_sector
              }}
            </template>

            <template v-slot:[`item.add`]="{ item }">
              <!-- Tooltip para "Visualizar Visitante" -->
              <v-tooltip color="green" bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-icon
                    color="green"
                    class="mr-2"
                    v-bind="attrs"
                    v-on="on"
                    :disabled="
                      item.historical_movement_person.final_permanence != null
                    "
                    @click="addVisitant(item)"
                  >
                    mdi-eye
                  </v-icon>
                </template>
                <span>Visualizar Visitante</span>
              </v-tooltip>

              <!-- Tooltip para "Editar Visitante" -->
              <v-tooltip color="primary" bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-icon
                    color="primary"
                    class="mr-2"
                    v-bind="attrs"
                    v-on="on"
                    dense
                    :disabled="
                      item.historical_movement_person.final_permanence != null
                    "
                    @click="editVisitant(item)"
                  >
                    mdi-pencil
                  </v-icon>
                </template>
                <span>Editar Visitante</span>
              </v-tooltip>

              <!-- Tooltip para "Registrar Saída" -->
              <v-tooltip color="red" bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-icon
                    color="red"
                    class="mr-2"
                    v-bind="attrs"
                    v-on="on"
                    dense
                    :disabled="
                      item.historical_movement_person.final_permanence != null
                    "
                    @click="visitorExit(item)"
                  >
                    mdi-door-open
                  </v-icon>
                </template>
                <span>Registrar Saída</span>
              </v-tooltip>
            </template>
            <template v-slot:[`item.atestado`]="{ item }">
              <!-- Tooltip para "Gerar atestado" -->
              <v-tooltip color="primary" bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-icon
                    color="primary"
                    class="mr-2"
                    v-bind="attrs"
                    dense
                    v-on="on"
                    :disabled="
                      !item.historical_movement_person.final_permanence
                    "
                    @click="getAttestation(item)"
                  >
                    mdi-file-pdf-box
                  </v-icon>
                </template>
                <span>Gerar Atestado</span>
              </v-tooltip>
            </template>
          </v-data-table>
        </v-row>
      </v-container>
    </div>
    <div v-if="$store.state.stepperVisitors">
      <TableVisitors />
    </div>
  </div>
</template>

<script>
import axios from "@/axios";
import TableVisitors from "../visitors/TableVisitors-comp.vue";
import fileDownload from "js-file-download";
import { visitorsMixin } from "../../../mixins/visitorsMixin";

export default {
  mixins: [visitorsMixin],
  data() {
    return {
      next: false,
      loading: false,
      hospitalPatient: [],
      patient: [],
      documentTypeList: [],
      admVisitors: [],
      headers: [
        {
          text: "Nº da Etiqueta",
          value: "sticker.sticker_number",
          align: "center",
        },
        { text: "Nome Social", value: "social_name", align: "center" },
        { text: "Nome", value: "name_person", align: "center" },
        { text: "Telefone", value: "phones[0].phone_number", align: "center" },
        {
          text: "Data de Entrada",
          value: "entry_date_and_time",
          align: "center",
        },
        { text: "Setor", value: "visitor_sector", align: "center" },
        // 'others_sectors'
        {
          text: "Data de Saída",
          value: "historical_movement_person.final_permanence",
          align: "center",
        },
        { text: "Ações", value: "add", align: "center" },
        {
          text: "Atestado de Comparecimento",
          value: "atestado",
          align: "center",
        },
      ],
      displayError: {
        display: false,
        message: [],
      },
      displaySuccess: {
        display: false,
        message: [],
      },
      dateMenu: false,
      search: {
        hospital_patient_name: "",
        hospital_bed: "",
        functional_unity: "",
        attendance_date: "",
        per_page: "",
      },
      options: {
        page: 1,
        itemsPerPage: 10,
        sortBy: [],
        sortDesc: [],
        totalItems: 0,
      },
      date: "",
    };
  },
  components: {
    TableVisitors,
  },
  created() {
    this.date = this.date.split("-").reverse().join("/");
    this.searching();

    if (this.$route.query.mode === "create") {
      this.form.document_type = this.$route.query.document_type || "";
      this.form.document_number = this.$route.query.document_number || "";
    }
  },

  computed: {
    maskDecider() {
      const documentID = this.search.document_type;
      if (documentID === 3) {
        return "###.###.###-##"; //cpf
      } else if (documentID === 1) {
        return "##.###.###-##"; //rg
      } else if (documentID === 2) {
        return "###########"; //cnh
      }
      return "";
    },
  },

  methods: {
    formatDateTime(dateTime) {
      if (!dateTime) return "";

      let [date, time] = dateTime.split(" ");
      let [year, month, day] = date.split("-");

      return `${day}-${month}-${year} ${time}`;
    },

    getAttestation(item) {
      let data = new Object();
      data.name = item.name_person;
      axios
        .post("historical-movement/administrative/report", data, {
          responseType: "blob",
        })
        .then((response) => {
          fileDownload(response.data, "atestado.pdf");
        });
    },

    searching() {
      this.loading = true;

      const params = {
        page: this.options.page,
        per_page: this.options.itemsPerPage,
        document_number: this.search.document_number,
        name: this.search.name,
      };

      axios
        .get(`person/search-administrative-visitor`, { params })
        .then((response) => {
          this.admVisitors = response.data.data;
          this.options.totalItems = response.data.total || 0;

          if (response.data.data.length === 0) {
            this.$swal({
              icon: "error",
              title: "Nenhum Visitante/Acompanhante Encontrado.",
              text: "Deseja cadastrar um novo?",
              showConfirmButton: true,
              confirmButtonText: "Sim",
              confirmButtonColor: "#43A047",
              showCancelButton: true,
              cancelButtonText: `Não`,
              reverseButtons: true,
              // timer: 3000,
            }).then((result) => {
              if (result.isConfirmed) {
                // usuário clicou em SIM → vai para tela de cadastro
                this.$router.push({
                  path: "/cad-adm-person",
                  query: {
                    document_type: this.search.document_type,
                    document_number: this.search.document_number,
                    mode: "create",
                  },
                });
              } else if (result.isDismissed) {
                this.$router.push({
                  path: "/dashboard",
                });
                // usuário clicou em NÃO → tela de DASHBOARD
                // return;
              }
            });
          }
        })
        .finally(() => {
          this.loading = false;
        });
    },

    // EDITAR VISITANTE
    editVisitant(item) {
      this.$router.push({
        path: "/cad-adm-person",
        query: { item: JSON.stringify(item), mode: "edit" },
      });
    },
    addVisitant(item) {
      this.$router.push({
        path: "/cad-adm-person",
        query: { item: JSON.stringify(item), mode: "view" },
      });
    },

    visitorExit(item) {
      let data = new Object();
      data.id_person = item.id;
      let now = new Date();
      now.setMinutes(now.getMinutes() - now.getTimezoneOffset()); // Ajusta para o fuso local
      let formattedDate = now.toISOString().slice(0, 19).replace("T", " ");
      data.final_permanence = formattedDate;

      axios
        .post(`historical-movement/administrative/finalize`, data)
        .then((response) => {
          this.$swal({
            icon: "success",
            title: "Saída de Visitante Finalizado com Sucesso!",
            html: `<p>${response.data.message}</p>`,
            showConfirmButton: false,
            timer: 3000,
          });
          this.searching();
        })
        .catch((error) => {
          this.$swal({
            icon: "error",
            title: "Ocorreu um erro!",
            html: `<p>${error.response.data.message}</p>`,
            showConfirmButton: false,
            timer: 3000,
          });
        });
    },
    formatDate(date) {
      this.date = date.split("-").reverse().join("/");
    },
    btlimpar() {
      this.search.hospital_patient_name = "";
      this.search.functional_unity = "";
      this.search.hospital_bed = "";
      this.search.attendance_date = "";
      this.date = "";
      (this.search.document_type = null), (this.search.document_number = null);
    },
  },
};
</script>

<style>
.v-data-table {
  font-family: Arial, Helvetica, sans-serif;
  font-weight: 600;
  font-size: 16px;
  color: #000000;
  width: 100%;
  border-radius: 10px;
  margin-bottom: 10px;
}
</style>
